import * as R from 'ramda';
import { useSelector } from 'react-redux';

import { PosPlugin } from 'plugins/plugin';
import { reactcursively } from 'utils/react';
import { getTotal } from 'reducers/ShoppingCart';

const ordinaryGiftCardIconTestId = 'payment-giftcard-icon';
const ordinaryGiftCardTitleTestId = 'payment-giftcard-name';
const customGiftCardIconTestId = 'payment-custom-giftcard-icon';
const customGiftCardTitleTestId = 'payment-custom-giftcard-name';

function hideElement() {
  return null;
}
function increaseTextSize(element) {
  return R.assocPath(['props', 'style', 'fontSize'], {
    fontSize: '16px',
  })(element);
}
function isEitherOrdinaryOrCustomGiftCardIcon(el) {
  return R.anyPass([
    R.pathEq(['props', 'data-testid'], customGiftCardIconTestId),
    R.pathEq(['props', 'data-testid'], ordinaryGiftCardIconTestId),
  ])(el);
}
function isEitherOrdinaryOrCustomGiftCardText(el) {
  return R.anyPass([
    R.pathEq(['props', 'data-testid'], ordinaryGiftCardTitleTestId),
    R.pathEq(['props', 'data-testid'], customGiftCardTitleTestId),
  ])(el);
}

function updateElement(element) {
  return R.cond([
    [isEitherOrdinaryOrCustomGiftCardIcon, hideElement],
    [isEitherOrdinaryOrCustomGiftCardText, increaseTextSize],
    [R.T, R.identity],
  ])(element);
}

const hideKeyPadsOnGivexReturn = (shouldHide, element) => {
  return shouldHide ? null : element;
};

const WithoutGiftCardIcon: PosPlugin['UIKeyPad'] = ({ children }) => {
  const total = useSelector(getTotal);
  const shouldHide = total < 0;

  return reactcursively(
    R.pipe(updateElement, element =>
      hideKeyPadsOnGivexReturn(shouldHide, element),
    ),
  )(children);
};

export default WithoutGiftCardIcon;
